import { config } from "../../../config"
import React, { useState } from 'react';
import { useDispatch } from "react-redux";

import { getLogo } from "../../../layouts/layout";

import {
    FormGroup,
    Form,
    Row,
    Col,
    Input,
    Button
} from 'reactstrap';

// import img1 from '../../../assets/images/logo-icon-tcs.png';
import img2 from '../../../assets/images/big/auth-bg.jpg';
import { deviceApi } from '../../identity/reducers/identitySlice';

const sidebarBackground = {
    backgroundImage: "url(" + img2 + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center"
};

const RecoverPwd = () => {
    const [email, setEmail] = useState("");
    const dispatch = useDispatch();

    const doRecovery = (event) => {
        dispatch( deviceApi.passwordRecovery(email) );
        event.preventDefault();
    }

    return <div className={config.instance.id} id={config.instance.id}>
        {/*--------------------------------------------------------------------------------*/}
        {/*Recover Password Cards*/}
        {/*--------------------------------------------------------------------------------*/}
        <div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
            <div className="auth-box">
                <div id="loginform">
                    <div className="logo">
                        <span className="db"><img src={getLogo()} alt="logo" width="40" height="40" /></span>
                        <h5 className="font-medium mb-3">Recover Password</h5>
                    </div>
                    <Row>
                        <Col xs="12">
                            <Form className="mt-3" id="loginform" action="/">
                                <FormGroup>
                                    <Input 
                                        type="email" 
                                        name="emailid" 
                                        bsSize="lg" 
                                        id="uname" 
                                        placeholder="Email" 
                                        required 
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }} />
                                </FormGroup>
                                <Row className="mb-4">
                                    <Col xs="12">
                                        <Button color="primary" size="lg" type="submit" className="text-uppercase" block onClick={(event) => doRecovery(event)}>Reset</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>;
}

export default RecoverPwd;
